<script setup lang="ts">
import SeatPlate from './SeatPlate.vue'

import type { SeatClickEvent } from '@/components/table/types'

const props = withDefaults(
  defineProps<{
    mode?: 'left' | 'right'
    popupPlacement: 'top' | 'bottom' | 'left' | 'right'
    index: number
    disable?: boolean
    sitdown?: boolean
  }>(),
  { mode: 'left' }
)

const emit = defineEmits<{
  'seat-click': [SeatClickEvent]
}>()
</script>

<template>
  <seat-plate
    :view-mode="'mobile'"
    :popup-placement="popupPlacement"
    :avatar-placement="props.mode"
    @click="emit('seat-click', { index: props.index, empty: true })"
    :class="{ 'pointer-events-none!': props.disable && !props.sitdown }"
    class="empty-seat"
  >
    <template #avatar>
      <div
        :id="`empty-seat-${props.index}`"
        class="empty-seat__avatar"
        :class="`empty-seat__avatar--mobile`"
      >
        {{ !props.disable || props.sitdown ? '+' : '' }}
      </div>
    </template>
    <template #popper v-if="$slots.popup">
      <!-- <seat-request-panel :seat-index="index" /> -->
      <slot name="popup"></slot>
    </template>
    <div
      v-if="!props.disable && !props.sitdown"
      class="empty-seat__placeholder empty-seat__placeholder--mobile"
    >
      {{ $t('PokerTable.label.AddBot') }}
    </div>
    <div v-else-if="props.sitdown" class="empty-seat__placeholder empty-seat__placeholder--mobile">
      {{ $t('PokerTable.label.SitHere') }}
    </div>
  </seat-plate>
</template>

<style lang="scss">
.empty-seat {
  &__placeholder {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #292a339a, #1f20279a);
    position: relative;
    box-shadow:
      0 0 1px 0.6px rgba(49, 49, 53, 0.5),
      0 0 1px 0.6px rgba(65, 65, 70, 0);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(0.95 * var(--tw));
    font-weight: 500;
    word-wrap: break-word;
    color: #e4e4e499;
    padding-left: var(--seat-plate-padding-left);
    padding-right: var(--seat-plate-padding-right);

    &--mobile {
      background: none;
      box-shadow: none;
      font-size: 9px;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  &__avatar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #40424d;
    flex-shrink: 0;

    &--mobile {
      color: #ffffff66;
      font-size: 30px;
    }
  }

  .seat-plate__avatar {
    background: #171923a7;
    border: 1px #ffffff66 solid;
  }

  &.table__seat--desktop {
    height: auto;
    width: auto;

    &.seat-plate--right {
      margin-left: calc(5 * var(--tgw));
    }

    .empty-seat__placeholder--mobile {
      font-size: min(12px, calc(0.95 * var(--tw)));
      white-space: nowrap;
    }

    .seat-plate__avatar {
      width: calc(7.84 * var(--tgw));
      height: calc(7.84 * var(--tgw));
      transform: none;
      margin-bottom: calc(1 * var(--tgw));
    }
  }
}
</style>
